// This file is auto-generated by @hey-api/openapi-ts

import type { Client, ClientMeta, Options as Options2, RequestResult, TDataShape } from './client';
import { client } from './client.gen';
import type { CreateAccountData, CreateAccountErrors, CreateAccountResponses, CreateInstallationData, CreateInstallationErrors, CreateInstallationResponses, CreateSubAccountData, CreateSubAccountErrors, CreateSubAccountResponses, CreateZoneData, CreateZoneErrors, CreateZoneResponses, DeleteHierarchyData, DeleteHierarchyErrors, DeleteHierarchyResponses, GetAccountData, GetAccountErrors, GetAccountResponses, GetAccountsListData, GetAccountsListErrors, GetAccountsListResponses, GetInstallationData, GetInstallationErrors, GetInstallationResponses, GetInstallationsListData, GetInstallationsListErrors, GetInstallationsListResponses, GetLanguagesListData, GetLanguagesListErrors, GetLanguagesListResponses, GetOfferingsListData, GetOfferingsListErrors, GetOfferingsListResponses, GetRedirectUrlData, GetRedirectUrlErrors, GetRedirectUrlResponses, GetSubAccountData, GetSubAccountErrors, GetSubAccountResponses, GetSubAccountsListData, GetSubAccountsListErrors, GetSubAccountsListResponses, GetZoneData, GetZoneErrors, GetZoneResponses, GetZonesListData, GetZonesListErrors, GetZonesListResponses, PatchAccountData, PatchAccountErrors, PatchAccountResponses, PatchInstallationData, PatchInstallationErrors, PatchInstallationResponses, UpdateSubAccountData, UpdateSubAccountErrors, UpdateSubAccountResponses, UpdateZoneData, UpdateZoneErrors, UpdateZoneResponses } from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean, TResponse = unknown> = Options2<TData, ThrowOnError, TResponse> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: keyof ClientMeta extends never ? Record<string, unknown> : ClientMeta;
};

/**
 * Get list of accounts.
 */
export const getAccountsList = <ThrowOnError extends boolean = false>(options?: Options<GetAccountsListData, ThrowOnError>): RequestResult<GetAccountsListResponses, GetAccountsListErrors, ThrowOnError> => (options?.client ?? client).get<GetAccountsListResponses, GetAccountsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts',
    ...options
});

/**
 * Create account.
 */
export const createAccount = <ThrowOnError extends boolean = false>(options: Options<CreateAccountData, ThrowOnError>): RequestResult<CreateAccountResponses, CreateAccountErrors, ThrowOnError> => (options.client ?? client).post<CreateAccountResponses, CreateAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get account details.
 */
export const getAccount = <ThrowOnError extends boolean = false>(options: Options<GetAccountData, ThrowOnError>): RequestResult<GetAccountResponses, GetAccountErrors, ThrowOnError> => (options.client ?? client).get<GetAccountResponses, GetAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}',
    ...options
});

/**
 * Update account.
 */
export const patchAccount = <ThrowOnError extends boolean = false>(options: Options<PatchAccountData, ThrowOnError>): RequestResult<PatchAccountResponses, PatchAccountErrors, ThrowOnError> => (options.client ?? client).patch<PatchAccountResponses, PatchAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get redirect URL for authentication.
 */
export const getRedirectUrl = <ThrowOnError extends boolean = false>(options: Options<GetRedirectUrlData, ThrowOnError>): RequestResult<GetRedirectUrlResponses, GetRedirectUrlErrors, ThrowOnError> => (options.client ?? client).get<GetRedirectUrlResponses, GetRedirectUrlErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/authentication/{partner}/redirecturl',
    ...options
});

/**
 * Delete hierarchy.
 */
export const deleteHierarchy = <ThrowOnError extends boolean = false>(options: Options<DeleteHierarchyData, ThrowOnError>): RequestResult<DeleteHierarchyResponses, DeleteHierarchyErrors, ThrowOnError> => (options.client ?? client).delete<DeleteHierarchyResponses, DeleteHierarchyErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/hierarchies/{hierarchyId}',
    ...options
});

/**
 * Get list of installations.
 */
export const getInstallationsList = <ThrowOnError extends boolean = false>(options: Options<GetInstallationsListData, ThrowOnError>): RequestResult<GetInstallationsListResponses, GetInstallationsListErrors, ThrowOnError> => (options.client ?? client).get<GetInstallationsListResponses, GetInstallationsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/installations',
    ...options
});

/**
 * Create a new installation.
 */
export const createInstallation = <ThrowOnError extends boolean = false>(options: Options<CreateInstallationData, ThrowOnError>): RequestResult<CreateInstallationResponses, CreateInstallationErrors, ThrowOnError> => (options.client ?? client).post<CreateInstallationResponses, CreateInstallationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/installations',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get installation details.
 */
export const getInstallation = <ThrowOnError extends boolean = false>(options: Options<GetInstallationData, ThrowOnError>): RequestResult<GetInstallationResponses, GetInstallationErrors, ThrowOnError> => (options.client ?? client).get<GetInstallationResponses, GetInstallationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/installations/{installationId}',
    ...options
});

/**
 * Update an existing installation.
 */
export const patchInstallation = <ThrowOnError extends boolean = false>(options: Options<PatchInstallationData, ThrowOnError>): RequestResult<PatchInstallationResponses, PatchInstallationErrors, ThrowOnError> => (options.client ?? client).patch<PatchInstallationResponses, PatchInstallationErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/installations/{installationId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get list of languages.
 */
export const getLanguagesList = <ThrowOnError extends boolean = false>(options?: Options<GetLanguagesListData, ThrowOnError>): RequestResult<GetLanguagesListResponses, GetLanguagesListErrors, ThrowOnError> => (options?.client ?? client).get<GetLanguagesListResponses, GetLanguagesListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/languages',
    ...options
});

/**
 * Get list of offerings.
 */
export const getOfferingsList = <ThrowOnError extends boolean = false>(options?: Options<GetOfferingsListData, ThrowOnError>): RequestResult<GetOfferingsListResponses, GetOfferingsListErrors, ThrowOnError> => (options?.client ?? client).get<GetOfferingsListResponses, GetOfferingsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/offerings',
    ...options
});

/**
 * Get list of sub-accounts.
 */
export const getSubAccountsList = <ThrowOnError extends boolean = false>(options: Options<GetSubAccountsListData, ThrowOnError>): RequestResult<GetSubAccountsListResponses, GetSubAccountsListErrors, ThrowOnError> => (options.client ?? client).get<GetSubAccountsListResponses, GetSubAccountsListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/subaccounts',
    ...options
});

/**
 * Create a new sub-account.
 */
export const createSubAccount = <ThrowOnError extends boolean = false>(options: Options<CreateSubAccountData, ThrowOnError>): RequestResult<CreateSubAccountResponses, CreateSubAccountErrors, ThrowOnError> => (options.client ?? client).post<CreateSubAccountResponses, CreateSubAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/subaccounts',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get details of a specific sub-account.
 */
export const getSubAccount = <ThrowOnError extends boolean = false>(options: Options<GetSubAccountData, ThrowOnError>): RequestResult<GetSubAccountResponses, GetSubAccountErrors, ThrowOnError> => (options.client ?? client).get<GetSubAccountResponses, GetSubAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/subaccounts/{subAccountId}',
    ...options
});

/**
 * Update an existing sub-account.
 */
export const updateSubAccount = <ThrowOnError extends boolean = false>(options: Options<UpdateSubAccountData, ThrowOnError>): RequestResult<UpdateSubAccountResponses, UpdateSubAccountErrors, ThrowOnError> => (options.client ?? client).put<UpdateSubAccountResponses, UpdateSubAccountErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/subaccounts/{subAccountId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the list of zones for the account.
 */
export const getZonesList = <ThrowOnError extends boolean = false>(options: Options<GetZonesListData, ThrowOnError>): RequestResult<GetZonesListResponses, GetZonesListErrors, ThrowOnError> => (options.client ?? client).get<GetZonesListResponses, GetZonesListErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/zones',
    ...options
});

/**
 * Create a new zone.
 */
export const createZone = <ThrowOnError extends boolean = false>(options: Options<CreateZoneData, ThrowOnError>): RequestResult<CreateZoneResponses, CreateZoneErrors, ThrowOnError> => (options.client ?? client).post<CreateZoneResponses, CreateZoneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/zones',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});

/**
 * Get the details of a specific zone.
 */
export const getZone = <ThrowOnError extends boolean = false>(options: Options<GetZoneData, ThrowOnError>): RequestResult<GetZoneResponses, GetZoneErrors, ThrowOnError> => (options.client ?? client).get<GetZoneResponses, GetZoneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/zones/{zoneId}',
    ...options
});

/**
 * Update an existing zone.
 */
export const updateZone = <ThrowOnError extends boolean = false>(options: Options<UpdateZoneData, ThrowOnError>): RequestResult<UpdateZoneResponses, UpdateZoneErrors, ThrowOnError> => (options.client ?? client).put<UpdateZoneResponses, UpdateZoneErrors, ThrowOnError>({
    security: [{ scheme: 'bearer', type: 'http' }],
    url: '/accounts/{accountId}/zones/{zoneId}',
    ...options,
    headers: {
        'Content-Type': 'application/json',
        ...options.headers
    }
});
